import Axios from "axios";
import { getUserLocalStorageToken, logout } from "core/api";
import { toastr } from "react-redux-toastr";

import environment from "../environment/environment";
import ApiError from "./apiError";

const SUBSCRIPTION_KEY = `${environment.SUBSCRIPTION_KEY}`;

const parseJSON = (response) => response.data;

const onLogout = () => logout();

const throwError = (json, status) => {
	throw new ApiError(status, json);
};

const checkStatus = (response) => {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}
	return response.json().then((json) => throwError(json, response.status));
};

const request = async (
	url,
	options = {},
	timeoutRequest = 120000,
	responseType = undefined,
) => {
	try {
		let isRequesting = true;
		const { CancelToken } = Axios;
		const source = CancelToken.source();
		const response = Axios(url, {
			cancelToken: source.token,
			method: "GET",
			responseType,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
				"Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
				Authorization: `Bearer ${sessionStorage.getItem("structured:api-token") || getUserLocalStorageToken()}`,
				...options.headers,
			},
			...options,
		});

		setTimeout(() => {
			if (isRequesting) {
				source.cancel("Tente novamente");
			}
		}, timeoutRequest);

		response.then(() => {
			isRequesting = false;
		});
		const checked = await checkStatus(await response);

		return parseJSON(checked);
	} catch (e) {
		if (e.response && e.response.status === 401) {
			toastr.confirm("Sua sessão expirou", {
				onOk: onLogout,
				disableCancel: true,
			});
		}

		return {
			error: e,
		};
	}
};

export default request;
